// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3aGQC","header":"PatientBlock_header__29Fdx","label":"PatientBlock_label__L0jaY","option":"PatientBlock_option__2Fulv"};